import { useState, useEffect } from 'react'
import axios from 'axios'
import { FiEdit, FiMoreVertical, FiTrash } from "react-icons/fi";
import { MdOutlineLibraryAdd } from 'react-icons/md';
import AddEpgModal from './modals/add_epg_modal';
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { AxiosInstance } from '../../../common/Loader/axios.config';

interface Program {
    _id: string;
    title: string;
    description: string;
    starttime: string;
    endtime: string;
}

interface ProgramGuideProps {
    contentName: string;
    projectID: string;
    productID: string;
}

export const ProgramGuide = ({ contentName, projectID, productID }: ProgramGuideProps) => {
    const [programs, setPrograms] = useState<Program[]>([]);
    const [loading, setLoading] = useState(false)
    const [selectedProgram, setSelectedProgram] = useState<Program | null>(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isAdding, setIsAdding] = useState(false);

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const getPrograms = async () => {
        setLoading(true);
        try {
            const response = await AxiosInstance.get('/projects', {
                params: {
                    item: ""
                }
            });
            console.log("Response", response.data);
            console.log("Content Name", contentName);
            console.log("Project ID", projectID);
            if (response.status == 200) {
                const filteredProjects = (response.data as any).message.filter((project: any) => project._id === projectID);
                console.log("Filtered Projects", filteredProjects);
                console.log("Programs", filteredProjects[0].epgs);
                setPrograms(filteredProjects[0].epgs);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        getPrograms();
    }, []);

    const formatTime = (timeString: string) => {
        const date = new Date(timeString);
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const handleDelete = async (projectID: string, title: string) => {
        const { isConfirmed } = await Swal.fire({
            title: 'Are you sure?',
            text: `You are about to delete the program: ${title}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (!isConfirmed) return;

        setIsDeleting(true);
        try {
            const body = {
                title
            };

            const response = await AxiosInstance.delete(`/${projectID}/epg`, { data: body });
            console.log("Delete program:", response);

            if (response.data.status === "success") {
                await Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Program deleted successfully',
                    timer: 2000,
                    showConfirmButton: false
                });

                getPrograms();
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to delete program',
                    timer: 3000,
                    showConfirmButton: false
                });
            }

        } catch (error) {
            console.error('Error deleting program:', error);
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete program',
                timer: 3000,
                showConfirmButton: false
            });
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <div className='w-full m-0'>
            <p className="text-lg font-bold text-white text-center">{contentName} Programs Guide</p>
            {loading ? (
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-white my-40"></div>
                </div>
            ) : (
                <div className="w-full flex flex-col items-end justify-end">
                    <button
                        onClick={() => setIsAdding(true)}
                        className="bg-primary text-white px-3 py-2 m-4 rounded flex items-center gap-x-1 hover:scale-105"

                    >
                        <MdOutlineLibraryAdd size={20} />
                        <p className="font-bold text-lg">New</p>
                    </button>
                    <div className="w-full overflow-x-auto">
                        <table className="min-w-full bg-brand-background-color text-white">
                            <thead>
                                <tr className="bg-brand-stroke-color text-left">
                                    <th className="px-6 py-3 text-sm font-medium">Program</th>
                                    <th className="px-6 py-3 text-sm font-medium">Description</th>
                                    <th className="px-6 py-3 text-sm font-medium">Start Time</th>
                                    <th className="px-6 py-3 text-sm font-medium">End Time</th>
                                    <th className="px-6 py-3 text-sm font-medium">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {programs.map((program) => (
                                    <tr key={program._id} className="border-t border-brand-stroke-color">
                                        <td className="px-6 py-4 text-sm">{program.title}</td>
                                        <td className="px-6 py-4 text-sm">{program.description}</td>
                                        <td className="px-6 py-4 text-sm">{formatTime(program.starttime)}</td>
                                        <td className="px-6 py-4 text-sm">{formatTime(program.endtime)}</td>
                                        <td className="px-6 py-4 text-sm">
                                            <button
                                                onClick={(e) => handleDelete(program.project_id, program.title)}
                                                className="bg-brand-stroke-color text-white px-3 py-2 rounded flex items-center"
                                            >
                                                <MdDeleteForever className='hover:scale-105 hover:text-danger' size={20} />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {isAdding && (
                <AddEpgModal isOpen={isAdding} onClose={() => setIsAdding(false)} project={projectID} fetchPrograms={getPrograms} />
            )}
        </div>
    );
};